import { clsx } from 'clsx';
import { FC, useEffect } from 'react';

import { IntersectionObserverHandler } from '@/general/components/IntersectionObserverHandler/IntersectionObserverHandler';
import { RecentSearch } from '@/hygiene/components/flexible-content/RecentSearch/RecentSearch';
import { RecentFilterSearch } from '@/hygiene/components/flexible-content/RecentSearch/RecentSearch.type';
import { pushToDataLayerFeatureEngagement } from '@/utils/pushToDataLayerFeatureEngagement';

type RecentSearchesProps = {
  recentSearches: RecentFilterSearch[];
  className?: string;
};

export const RecentSearches: FC<RecentSearchesProps> = ({ recentSearches, className }) => {
  useEffect(() => {
    pushToDataLayerFeatureEngagement({
      event: 'feature_engagement',
      payload: {
        type: 'load',
        feature: 'recentSearch',
        component: 'list',
      },
    });
  }, []);

  const onClickSearch = (index: number) => {
    pushToDataLayerFeatureEngagement({
      event: 'feature_engagement_click',
      payload: {
        type: 'click',
        feature: 'recentSearch',
        component: 'list',
        index,
      },
    });
  };
  return (
    <IntersectionObserverHandler
      threshold={0.5}
      margins="0px"
      onIntersecting={() => {
        pushToDataLayerFeatureEngagement({
          event: 'feature_engagement',
          payload: {
            type: 'view',
            feature: 'recentSearch',
            component: 'list',
          },
        });
      }}
    >
      <section
        className={clsx(className, 'relative flex h-full w-full flex-col gap-6 sm:gap-8 md:w-xs md:gap-10 lg:w-sm')}
      >
        <h2 className="c-fs-h4 m-0 text-left font-extrabold text-tex-def-tie1">Recent searches</h2>
        <div
          className="flex h-full flex-col gap-4 sm:flex-row md:flex-col"
          data-testid="RecentSearches-searches-container"
        >
          {recentSearches.map((search, index) => (
            <RecentSearch key={search.id} className="basis-1/3" {...search} onClick={() => onClickSearch(index)} />
          ))}
        </div>
      </section>
    </IntersectionObserverHandler>
  );
};
